import { Link } from "react-router-dom";
import { Instagram, ArrowUpRight } from "lucide-react";
import { NAV, BRAND } from "@/lib/siteData";

export const Footer = () => (
  <footer className="relative bg-void border-t border-white/10 pt-20 pb-24 md:pb-12" data-testid="site-footer">
    <div className="container-x">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-8">
        <div className="md:col-span-4">
          <img src={BRAND.logo} alt="Vivek Parekh Production" className="h-16 w-auto mb-6" />
          <p className="text-white/50 text-sm leading-relaxed max-w-xs font-light">
            A Mumbai-based creative production house specializing in ad films and movie associations — producing since {BRAND.founded}.
          </p>
          <a
            href={BRAND.instagramUrl}
            target="_blank"
            rel="noreferrer"
            data-testid="footer-instagram"
            className="mt-6 inline-flex items-center gap-2 text-gold hover:text-champagne transition-colors text-sm"
          >
            <Instagram size={18} /> {BRAND.instagramHandle}
          </a>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-[0.3em] text-white/40 mb-5">Navigate</h4>
          <ul className="space-y-3">
            {NAV.map((n) => (
              <li key={n.id}>
                <a href={`/#${n.id}`} className="text-white/70 hover:text-gold transition-colors text-sm">{n.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.3em] text-white/40 mb-5">Services</h4>
          <ul className="space-y-3">
            <li><Link to="/movie-integrations" className="text-white/70 hover:text-gold transition-colors text-sm">Brand Integration</Link></li>
            <li><a href="/#ad-films" className="text-white/70 hover:text-gold transition-colors text-sm">Ad Film</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.3em] text-white/40 mb-5">Contact</h4>
          <ul className="space-y-3 text-sm text-white/70">
            <li><a href={BRAND.phoneHref} className="hover:text-gold transition-colors">{BRAND.phone}</a></li>
            <li><a href={`mailto:${BRAND.email}`} className="hover:text-gold transition-colors break-all">{BRAND.email}</a></li>
            <li className="text-white/50">{BRAND.address}</li>
            <li className="text-white/50">{BRAND.hours}</li>
          </ul>
          <a href="/#contact" className="mt-5 inline-flex items-center gap-1 text-gold text-sm group">
            Start a Project <ArrowUpRight size={16} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
          </a>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/40 md:pr-24">
        <p>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
        <div className="flex gap-6">
          <Link to="/privacy" className="hover:text-gold transition-colors">Privacy Policy</Link>
          <Link to="/terms" className="hover:text-gold transition-colors">Terms &amp; Conditions</Link>
        </div>
      </div>
    </div>
  </footer>
);
